import React, { useState } from "react";
import { Box, Typography, Stack, Button } from "@mui/material";

import { useTheme } from "@mui/material/styles";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { signUpSchema } from "../../validate/authentication";
import { EmailInput, PasswordInput } from "../ui-elements/inputs";
import InputPassword from "../ui-elements/input-password";
import {
  btnApple,
  btnGoogle,
  btnStyOne,
  line,
  lineText,
} from "../ui-elements/styles-button";
import { Image } from "@mui/icons-material";
import { Apple, Google } from "../ui-elements/svg-icons";
import { useNotificationService } from "../../hooks/notification";
import { useMutation } from "@tanstack/react-query";
import { apiSignIn } from "../../api/authentication";
import { LoadingButton } from "@mui/lab";
import { Link, replace, useNavigate } from "react-router-dom";
import { PATH_AUTH, PATH_DASHBOARD } from "../../routes/path";
import { updateAccessToken } from "../../utils/storage";

export const SignInDetails = ({}) => {
  const { showNotification } = useNotificationService();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  // set up validation
  const {
    register,
    formState: { errors, isSubmitSuccessful },
    handleSubmit,
  } = useForm({
    resolver: zodResolver(signUpSchema),
  });

  const mutation = useMutation({
    mutationFn: apiSignIn,
    onSuccess: (data) => {
      // Handle error
      if (data?.status === "error") {
        if ("details" in data) {
          if (data?.details === "Account is not activated.") {
            showNotification(
              "Your account is not activated. Please check your email for activation link.",
              "error"
            );
            navigate(PATH_AUTH.otp, {
              state: {
                email: email,
              },
            });
            return;
          }
          showNotification(data?.details ?? "", "error");
          return;
        }
      }
      //  Handle success
      if (data?.status == 200) {
        const { access_token, expires_in, token_type } = data.data;
        updateAccessToken(access_token, expires_in, token_type);
        navigate(PATH_DASHBOARD.root, { replace: true });
      }
    },
    onError: (error) => {
      console.error("Process failed", error);
      // Handle error
      showNotification("Process failed", "error");
    },
  });
  const on_submit = async (values: any): Promise<void> => {
    const { email, password } = values;
    setEmail(email);
    const data = { password: password, email: email };
    mutation.mutate(data);
  };
  return (
    <Box sx={{ width: "80%", mx: "auto" }}>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        onSubmit={handleSubmit(on_submit)}
      >
        <EmailInput
          errors={errors}
          labelText="Email"
          placeholder="Enter email"
          register={register}
        />
        <PasswordInput
          errors={errors}
          placeholder="Enter password"
          labelText="Password"
          register={register}
        />
        <Link to={PATH_AUTH.reset} style={{ color: "#000" }}>
          <Typography sx={{ mb: 2 }} variant="body2">
            Forgot password
          </Typography>{" "}
        </Link>
        <LoadingButton
          loading={mutation.isPending}
          type="submit"
          variant="contained"
          sx={btnStyOne}
        >
          Continue
        </LoadingButton>
        <Box sx={{ height: 100 }} />
        {/* <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
          sx={{
            my: 1,
          }}
        >
          <Box sx={line} />
          <Typography sx={lineText}>or</Typography>
          <Box sx={line} />
        </Box>
        <Box>
          <Button startIcon={<Google />} sx={btnGoogle}>
            Continue with Google
          </Button>

          <Button startIcon={<Apple />} sx={btnApple}>
            Continue with Apple ID
          </Button>
        </Box> */}
      </Box>
    </Box>
  );
};
